import React, {useContext, useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import * as Actions from '../../../store/actions';
import {PAGES_URL} from '../../../helpers/constants';
import {PageContext} from '../../../helpers/context';
import Layout from '../HomeLayout';
import {PerformBtn, ViewLink} from '../../../components/lookupComponents';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {batchLookupImg, individualLookupImg} from 'assets/images/images';

import SingleBusinessLookupModal from '../Modals/SingleBusinessLookupModal';
import BatchBusinessLookupModal from '../Modals/BatchBusinessLookupModal';

function BusinessLookup({auth: {userDetails}}) {
  const [openSingleLookup, setOpenSL] = useState(false);
  const [openBatchLookup, setOpenBL] = useState(false);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('lookup');
  }, [setPageName]);

  const {
    performSingleBusinessLookup,
    viewSingleBusinessLookup,
    performBatchBusinessLookup,
    viewBatchBusinessLookup,
  } =
    useMemo(() => userDetails?.permissions?.lookupPermissions, [userDetails]) ||
    {};

  const isCompanyVerified = userDetails?.company?.verified;
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 96);

  return (
    <Layout>
      <SingleBusinessLookupModal open={openSingleLookup} setOpen={setOpenSL} />

      <BatchBusinessLookupModal open={openBatchLookup} setOpen={setOpenBL} />

      <div className="flex flex-col mt-6 sm:flex-row items-stretch gap-10 sm:gap-4 lg:gap-10">
        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 gap-2 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          <div className="py-8 px-6 w-full">
            <div className="rounded-t-xl w-full border-transparent">
              <h2 className="text-deepBlue mb-1 text-lg font-semibold">
                Perform Single lookup
              </h2>
            </div>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Verify business identity seamlessly
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PerformBtn
                permitted={performSingleBusinessLookup}
                setOpen={setOpenSL}
                isCompanyVerified={isCompanyVerified}
                btnText="Perform Single lookup"
              />
              <ViewLink
                permitted={viewSingleBusinessLookup}
                route={PAGES_URL.BUSINESS_LOOKUP_SINGLE}
              />
            </div>
          </div>

          <div className="rounded-xl flex justify-center w-full">
            <img
              src={individualLookupImg}
              alt=""
              className="w-full p-2 rounded-xl"
            />
          </div>
        </div>

        <div
          style={{
            backgroundColor: lighterShade,
            borderColor: 'rgba(230, 240, 255, 0.5)',
          }}
          className="rounded-xl pb-0 gap-2 flex flex-col items-start sm:max-w-[406px] w-full border"
        >
          <div className="py-8 px-6 w-full">
            <h2 className="text-deepBlue mb-1 text-lg font-semibold">
              Perform Batch lookup{' '}
            </h2>
            <p className="text-[#8E90A9] w-full border tracking-[-0.01em] border-transparent text-base font-light">
              Upload and verify multiple businesses with ease
            </p>
            <div className="w-full flex flex-col mt-8 lg:flex-row items-start lg:items-center gap-2">
              <PerformBtn
                permitted={performBatchBusinessLookup}
                setOpen={setOpenBL}
                isCompanyVerified={isCompanyVerified}
                btnText="Perform Batch lookup"
              />
              <ViewLink
                permitted={viewBatchBusinessLookup}
                route={PAGES_URL.BUSINESS_LOOKUP_BATCH}
              />
            </div>
          </div>{' '}
          <div className="rounded-xl flex justify-center w-full">
            <img
              src={batchLookupImg}
              alt=""
              className="w-full p-2 rounded-xl"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default connect(state => state, Actions)(BusinessLookup);
